import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { HeaderComponent } from './components/header/header.component'
import { MenuComponent } from './components/menu/menu.component'
import { SidebarComponent } from './components/sidebar/sidebar.component'
import { NotificationModalService } from '@notifications/services/notification-modal.service'
import { NotificationsService } from '@notifications/services/notifications.service'

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, MenuComponent, SidebarComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent {
  notificationService = inject(NotificationsService)
  notificationsModalService = inject(NotificationModalService)
}
